<template>
    <div>
        <!--提示标题栏-->
        <div style="width: 88%;height: 40px;line-height:40px;">
            <div style="
            background-color: #adadad;
            width: 150px;
            height: 40px;
            text-align: center;
            vertical-align: middle;
            float: left;">
                大转盘皮肤
            </div>
            <div style="
            background-color: #adadad;
            margin-left: 2px;
            width: 35%;
            height: 40px;
            text-align: center;
            color: #adadad;
            float: left;">
                大转盘皮肤
            </div>
        </div>
        <!--皮肤配置-->
        <div style="height: 90px;">
            <el-form ref="ecxForm" label-width="150px">
                <el-form-item label="选择皮肤" prop="appType"
                              style="margin-top: 50px">
                    <el-select v-model="skinValue" :disabled="false"
                               placeholder="选择皮肤" style="width: 15%;">
                        <el-option value="0" label="默认皮肤">默认皮肤</el-option>
                        <el-option value="1" label="端午节皮肤">端午节皮肤</el-option>

                    </el-select>
                    <div style="height: 80px;width: 200px;margin-top: -70px;
                    margin-left: 315px">
                        <img :src="modelImgUrl"/>
                    </div>
                </el-form-item>


            </el-form>
        </div>
        <!--奖品配置-->
        <div style="width: 88%;height: 40px;line-height:40px;">
            <div style="
            background-color: #adadad;
            width: 150px;
            height: 40px;
            text-align: center;
            vertical-align: middle;
            float: left;">
                中奖奖项设置
            </div>
            <div style="
            background-color: #adadad;
            margin-left: 2px;
            width: 35%;
            height: 40px;
            text-align: center;
            color: #adadad;
            float: left;">
                中奖奖项设置
            </div>
        </div>
        <el-button type="primary" @click="addPrize()" style="margin-top: 10px">
            +添加奖品
        </el-button>
        <!--奖品列表-->
        <el-table :data="tableData" border
                  style="width: 100%;text-align: center"
                  height="250">
            <el-table-column prop="act_name" label="等级">
            </el-table-column>
            <el-table-column prop="act_name" label="名称">
            </el-table-column>
            <el-table-column prop="act_name" label="类型">
            </el-table-column>
            <el-table-column prop="act_name" label="数量">
            </el-table-column>
            <el-table-column prop="act_name" label="概率">
            </el-table-column>
            <el-table-column label="操作" width="350">
                <template scope="scope">
                    <el-button size="small" type="text">
                        编辑
                    </el-button>
                    <el-button size="small" type="text">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--弹窗-->
        <el-dialog title="奖项设置" style="font-style: revert;"
                   :visible.sync="dialogFormVisible"
                   :modal-append-to-body="false"
                    @close="closeDialog()">
            <div style="height: 1px;background-color: #adadad;margin-top: -30px"></div>
            <el-form :model="ecxForm" :rules="actrules" ref="ecxForm"
                     label-width="150px" class="demo-ruleForm" style="height: 530px">
                <el-form-item label="奖品等级" prop="prizeLevel">
                    <el-select v-model="ecxForm.prizeLevel"
                               placeholder="请选择奖品等级" @change="changePrizeLevel()">
                        <el-option value="0" label="一等奖">一等奖</el-option>
                        <el-option value="1" label="二等奖">二等奖</el-option>
                        <el-option value="3" label="三等奖">三等奖</el-option>
                        <el-option value="4" label="四等奖">四等奖</el-option>
                        <el-option value="5" label="五等奖">五等奖</el-option>
                        <el-option value="6" label="六等奖">六等奖</el-option>
                        <el-option value="7" label="七等奖">七等奖</el-option>
                        <el-option value="8" label="谢谢参与">谢谢参与</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="奖品名称" prop="prizeName" style="margin-top: 20px">
                    <el-input v-model="ecxForm.prizeName" placeholder="奖品名称"
                              style="width: 35%;" :disabled="isCheckStatus">
                    </el-input>
                </el-form-item>
                <el-form-item label="奖品类型" prop="prizeType" style="margin-top: 20px;width: 100%;">
                    <el-radio-group v-model="ecxForm.prizeType"
                                    @change="radioStatus()"
                                    style="width: 100%">
                        <el-radio label="0" value="0" style="margin-top: 10px">优惠券</el-radio>
                        <el-select v-model="ecxForm.couponCode"
                                   placeholder="请选择奖品等级"
                                   style="margin-left: 70px"
                                   v-show="isCouponCode"
                                   @change="changeCouponCode()">
                            <el-option value="0" label="一等奖">一等奖</el-option>
                            <el-option value="1" label="二等奖">二等奖</el-option>
                            <el-option value="3" label="三等奖">三等奖</el-option>
                            <el-option value="4" label="四等奖">四等奖</el-option>
                            <el-option value="5" label="五等奖">五等奖</el-option>
                            <el-option value="6" label="六等奖">六等奖</el-option>
                            <el-option value="7" label="七等奖">七等奖</el-option>
                            <el-option value="8" label="谢谢参与">谢谢参与</el-option>
                        </el-select>
                        <br/>
                        <el-radio label="1" value="1" style="margin-top: 20px">提货码活动</el-radio>
                        <el-input v-model="ecxForm.DcCode" placeholder="请输入提货码活动Id"
                                  style="width: 33%;margin-left: 40px"
                                  v-show="isDcCode">
                        </el-input>
                        <br/>
                        <el-radio label="2" value="2" style="margin-top: 20px">积分</el-radio>
                        <el-input v-model="ecxForm.integral" placeholder="请输入积分"
                                  style="width: 33%;margin-left: 85px"
                                  v-show="isIntegral">
                        </el-input>
                        <el-button v-text="ecxForm.textIntegral" type="text"
                                   :disabled="false"
                                   style="margin-left: 10px;color: black"
                                   v-show="isIntegralShow">
                        </el-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="奖品数量" prop="prizeName" style="margin-top: 20px">
                    <el-input v-model="ecxForm.prizeName" placeholder="奖品数量"
                              style="width: 35%;">
                    </el-input>
                    <el-button type="text" :disabled="true" style="margin-left: 10px;color: black">
                        份
                    </el-button>
                </el-form-item>
                <el-form-item label="奖品概率" prop="prizeName" style="margin-top: 20px">
                    <el-input v-model="ecxForm.prizeName" placeholder="奖品概率"
                              style="width: 35%;">
                    </el-input>
                    <el-button type="text" :disabled="true" style="margin-left: 10px;color: black">
                        %
                    </el-button>
                </el-form-item>
                <!--按钮-->
                <el-form-item style="float: right;margin-top: 100px;margin-right: 100px">
                    <el-button type="primary" @click="submitForm('ecxForm')"
                               id="save">保存
                    </el-button>
                    <el-button type="primary" @click="closeDialog()"
                               id="cancel">取消
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <!--上一步按钮 下一步按钮-->
        <el-form-item style="margin-top: 2%;margin-left: 26.5%;">
            <el-button type="primary" @click="lastStep('ecxForm')"
                       id="last_step">上一步
            </el-button>
            <el-button type="primary" @click="nextStep('ecxForm')"
                       id="next_step">下一步
            </el-button>
        </el-form-item>
    </div>
</template>

<script>
    export default {
        name: "WheelFragment",
        props: ["actId", "actStatus"],
        data() {
            return {
                modelImgUrl: "http://img5.imgtn.bdimg.com/it/u=3300305952,1328708913&fm=26&gp=0.jpg",
                skinValue: '0',
                tableData: [],
                /*弹窗选择*/
                dialogFormVisible: false,
                isCheckStatus: false,
                /*优惠券*/
                isCouponCode: false,
                /*提货码*/
                isDcCode: false,
                /*积分*/
                isIntegral: false,
                // 积分文本
                isIntegralShow: false,
                ecxForm: {
                    prizeLevel: '',
                    prizeName: '',
                    prizeType: '',
                    prizeNum: '',
                    prizeRate: '',
                    // 优惠券码
                    couponCode: '',
                    /*提货码*/
                    DcCode: '',
                    /*积分*/
                    integral: '',
                    textIntegral: '积分'
                },
                actrules: {
                    prizeLevel: [
                        {required: true, message: '选择奖品等级', trigger: 'change'},
                    ],
                    prizeName: [
                        {required: true, message: '请输入奖品名称', trigger: 'change'}
                    ],
                    prizeType: [
                        {required: true, }
                    ],
                    prizeNum: [
                        {required: true, message: '数量', trigger: 'change'}
                    ],
                    prizeRate: [
                        {required: true, message: '请输入中将概率', trigger: 'change'}
                    ],
                },
            }
        },
        created() {

        },
        methods: {
            /*添加奖品*/
            addPrize() {
                this.dialogFormVisible = true;
            },
            /*选择奖品等级*/
            changePrizeLevel() {

            },
            /*选择优惠券码*/
            changeCouponCode() {

            },
            /*奖品类型--单项选择*/
            radioStatus() {
                var type = this.ecxForm.prizeType;
                if (type === '0') {
                    this.isCouponCode = true;
                    this.isDcCode = false;
                    this.isIntegral = false;
                    this.isIntegralShow = false;
                }else if (type === '1') {
                    this.isCouponCode = false;
                    this.isDcCode = true;
                    this.isIntegral = false;
                    this.isIntegralShow = false;
                }else if (type === '2') {
                    this.isCouponCode = false;
                    this.isDcCode = false;
                    this.isIntegral = true;
                    this.isIntegralShow = true;
                }
            },
            /*关闭弹窗*/
            closeDialog(){
                this.dialogFormVisible =false;
                this.isCouponCode = false;
                this.isDcCode = false;
                this.isIntegral = false;
                this.isIntegralShow = false;

                this.ecxForm.prizeLevel='';
                this.ecxForm.prizeName='';
                this.ecxForm.prizeType='';
                this.ecxForm.prizeNum='';
                this.ecxForm.prizeRate='';
                this.ecxForm.couponCode='';
                this.ecxForm.DcCode='';
                this.ecxForm.integral='';
            },
            /*卡片跳转*/
            sendMsgToParent: function (step, id) {
                this.$emit("listenToChildEventDef", step, id)
            },
            /*下一页*/
            nextStep() {
                // this.updateStatus(1)
                this.sendMsgToParent("5", this.ecxForm.choiceActExcode)
            },
            /*上一页*/
            lastStep() {
                this.sendMsgToParent("3", this.actId)
            },
            /*修改活动状态*/
            updateStatus(status){
                //数据请求
                this.loading = true
                var params = {actStatus:status,actId:this.actId};
                //异步请求
                this.$http.post(this.admin_host+"/admin/activity/modify/status",params)
                    .then(response => {
                        if (response.status === 200) {
                            if (response.body.Code == "200") {
                                if (status == 0) {
                                    this.$message({showClose: true, message: '暂停成功', type: 'success'});
                                }else if (status == 1) {
                                    this.$message({showClose: true, message: '开启成功', type: 'success'});
                                }
                            }else {
                                this.$message({ showClose: true, message:response.body.Meta , type: 'error' });
                            }
                        }
                    },function(response){
                        console.log("fail")
                        this.$message({ showClose: true, message: '网络异常', type: 'error'});
                    })
            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// WheelFragment.vue?13fcc8bf